var $ = require('jquery');

var PageSlide = function PageSlide() {
	$('.page-slide').click(function() {
		$('html, body').clearQueue().animate({
			scrollTop: $('.row:first').offset().top
		});
	});
}

module.exports = PageSlide;